import { getTabCustomerId } from "@common/api/apiShared";

export function createPdfUrl(websitePath: string, language: string) {
    if (websitePath.includes("?")) {
        websitePath += "&";
    } else {
        websitePath += "?";
    }

    return encodeURIComponent(websitePath + `customerId=${getTabCustomerId()}&lang=${language}`);
}

export function isPdfRequest() {
    return !!getPdfToken();
}

export function getPdfToken() {
    return new URLSearchParams(window.location.search).get("pdfToken");
}
